"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Game = exports.GameProperties = void 0;
var account_1 = require("../account");
var content_1 = require("../content");
var game_results_1 = require("./game-results");
exports.GameProperties = ['id', 'content_id', 'version', 'server', 'options', 'language_id', 'subject_id', 'level_id', 'title', 'sub_title', 'description'];
var Game = /** @class */function () {
  function Game(values) {
    if (values === void 0) {
      values = {};
    }
    this.title = '';
    this.sub_title = '';
    this.description = '';
    this.version = 1;
    this.server = {
      version: 1
    };
    this.slides = [];
    /** Игроки */
    this.gamers = []; // TODO ? разбить на команды (opponent / teammate)
    var properties = exports.GameProperties;
    var instance = this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
    instance.gamers = (values.gamers || []).map(function (s) {
      return new account_1.User(s);
    });
    instance.slides = (values.slides || []).map(function (s) {
      return new content_1.LessonSlide(s);
    });
    instance.results = new game_results_1.GameResults(values.results || {});
    // instance.results.total_max_points = values.options.totalMaxPoints;
  }
  Object.defineProperty(Game.prototype, "totalPoints", {
    get: function () {
      return this.results ? this.results.totalPoints : 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Game.prototype, "maxPoints", {
    get: function () {
      return this.results ? this.results.maxPoints : 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Game.prototype, "percent", {
    get: function () {
      return this.results ? this.results.percent : 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Game.prototype, "slidesLength", {
    get: function () {
      return this.slides ? this.slides.length : 0;
    },
    enumerable: false,
    configurable: true
  });
  return Game;
}();
exports.Game = Game;
